<template>
	<div class="button-toggle-control">
		<label v-if="props.label" class="text-caption text-uppercase text-medium-emphasis">{{ props.label }}</label>
		<v-btn-toggle v-model="selected" mandatory :density="props.density" variant="outlined" color="primary" rounded="xl" divided>
			<v-btn v-for="item in normalizedItems" :key="item.value" :value="item.value" size="small">
				{{ props.titleKeyTranslate ? t(item.title) : item.title }}
			</v-btn>
		</v-btn-toggle>
	</div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useTranslator } from '@/composables/useTranslator';

const props = defineProps({
	label: { type: String, default: '' },
	items: { type: Array, default: () => [] },
	titleKey: { type: String, default: 'title' },
	valueKey: { type: String, default: 'value' },
	titleKeyTranslate: { type: Boolean, default: false },
	modelValue: { type: [String, Number, null], default: null },
	density: { type: String, default: 'compact' },
});

const emit = defineEmits(['update:modelValue', 'change']);
const t = useTranslator();

const normalizedItems = computed(() =>
	(Array.isArray(props.items) ? props.items : []).map((item) => {
		if (typeof item === 'string') return { value: item, title: item };
		return { value: item[props.valueKey], title: item[props.titleKey] };
	})
);

const selected = ref(props.modelValue ?? normalizedItems.value[0]?.value ?? null);

watch(
	() => props.modelValue,
	(val) => {
		if (val !== undefined && val !== selected.value) selected.value = val;
	}
);

watch(selected, (val) => {
	emit('update:modelValue', val);
	emit('change', val);
});
</script>

<style scoped lang="scss">
.button-toggle-control {
	display: flex;
	flex-direction: column;
	gap: 4px;

	.v-btn-toggle {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}
}
</style>
